import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	name: {
		id: 'eoc.heartbeats.name-input.no-translate',
		defaultMessage: 'Name',
		description: 'Label of the name input field.',
	},
	placeholder: {
		id: 'eoc.heartbeats.name-input-placeholder.no-translate',
		defaultMessage: 'Enter a name',
		description: 'Placeholder of the name input field.',
	},
	emptyNameErrorMessage: {
		id: 'eoc.heartbeats.name-input-error-message.no-translate',
		defaultMessage: 'Heartbeat name can not be empty.',
		description: 'Error text name input field.',
	},
});

export default messages;
